import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="search-results"
export default class extends Controller {
  connect() {
    // Initialize Swiper for all product images in search results
    this.initializeSwipers()
  }

  initializeSwipers() {
    // Check if initializeProductSwipers is available (legacy function)
    if (typeof window.initializeProductSwipers === 'function') {
      window.initializeProductSwipers()
    }
  }
}
